module.exports = __webpack_public_path__ + "img/sld_scb_25_t1_b1_green.3d87fcc4.svg";